import { render } from "./PerfettoMemory.vue?vue&type=template&id=244e86de&scoped=true&ts=true"
import script from "./PerfettoMemory.vue?vue&type=script&lang=ts"
export * from "./PerfettoMemory.vue?vue&type=script&lang=ts"

import "./PerfettoMemory.vue?vue&type=style&index=0&id=244e86de&scoped=true&lang=css"
import "./PerfettoMemory.vue?vue&type=style&index=1&id=244e86de&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244e86de"]])

export default __exports__